// import defaultSettings from "./defaultSettings";
import Vue from 'vue';
const common = {
    namespaced: true,
    state: {
        cartItems: [],
        sidebar_active_name: "/home",
        visitedViews: [{ path: "/home", query: {}, params: {}, fullPath: "/home", name: "home", meta: { affix: true, title: "首页" } }],
        cachedViews: ["/home"],
        //丁
        isKD: false,
        xhdbh: "",
        //丁
        Token: {},
        Power: {},
        settings: {},
        dysz: {},
        // defaultSettings,
        uuid: "",
        company: {},
        crm: {},
        bills: {
            xskd: {
                info: {},
                spTableData: [],
            },
            ghkd: {
                info: {},
                spTableData: [],
            },
            jhkd: {
                info: {},
                spTableData: [],
            },
            bjkd: {
                info: {},
                spTableData: [],
            },
            pdkd: {
                info: {},
                spTableData: [],
            },
        },
    },
    mutations: {
        DEL_TO_CART(state, item) {
            const findIndex = state.cartItems.findIndex(sp => sp.spxh === item.spxh);
            if (findIndex !== -1) {
                state.cartItems.splice(findIndex, 1);
            }
            // localStorage.setItem('cartItems', JSON.stringify(state.cartItems));

        },
        ADD_TO_CART(state, item) {
            const findIndex = state.cartItems.findIndex(sp => sp.spxh === item.spxh);
            if (findIndex !== -1) {
                let spsl = item.spsl + state.cartItems[findIndex].spsl;
                const newCartItem = { ...state.cartItems[findIndex], spsl: spsl };
                state.cartItems.splice(findIndex, 1, newCartItem);
            } else {
                state.cartItems.push(item);
            }
            console.log( state.cartItems);
            
            // localStorage.setItem('cartItems', JSON.stringify(state.cartItems));
        },
        // LOAD_CART_FROM_LOCAL_STORAGE(state) {
        //     const storedCart = localStorage.getItem('cartItems') || [];
        //     if (storedCart) {
        //         state.cartItems = JSON.parse(storedCart);
        //     }
        // },
        // SAVE_CART_TO_LOCAL_STORAGE(state) {
        //     console.log(state.cartItems);

        //     localStorage.setItem('cartItems', JSON.stringify(state.cartItems));
        // },
        //丁：关闭页签时候，如果是修改状态进行未保存提示
        getIskd(state, bol) {
            state.isKd = bol;
        },
        getXhdbh(state, xhdbh) {
            state.xhdbh = xhdbh;
        },
        //丁：关闭页签时候，如果是修改状态进行未保存提示
        CHANGE_SIDEBAR_ACTIVE_NAME(state, name) {
            Array.from(name).find((item) => item === "k") === "k"
                ? (state.sidebar_active_name = `${name}`)
                : (state.sidebar_active_name = name);
        },
        ADD_VISITED_VIEW(state, view) {
            if (!state.visitedViews.includes(view.fullPath)) {
                state.visitedViews.push(view);
            }
            if (!state.cachedViews.includes(view.fullPath)) {
                state.cachedViews.push(view.fullPath);
            }
        },
        DEL_VISITED_VIEW(state, view) {
            let visitedIndex = state.visitedViews.findIndex((item) => item.fullPath === view.fullPath);
            if (view.fullPath != "/home") {
                state.visitedViews.splice(visitedIndex, 1);
            }
            const filterView = state.visitedViews.filter((item) => item.fullPath === view.fullPath);
            if (filterView.length === 0) {
                state.cachedViews.splice(state.cachedViews.indexOf(view.fullPath), 1);
            }
        },
        UPDATE_TOKEN(state, token) {
            state.Token = token;
            token.uuid ? ((state.uuid = token.uuid), localStorage.setItem("uuid", token.uuid)) : "";
            localStorage.setItem("token", JSON.stringify(token));
        },
        UPDATE_POWER(state, power) {
            state.Power = power;
            localStorage.setItem("Power", JSON.stringify(power));
        },
        UPDATE_CRM(state, crm) {
            let Base64 = require("js-base64").Base64;
            // state.crm = crm;
            state.crm = Base64.encode(JSON.stringify(crm));
            localStorage.setItem("crm", state.crm);//可以停用
        },
        DOWNLOAD_SETTINGS(state, settings) {
            state.settings = settings;
            localStorage.setItem("settings", JSON.stringify(state.settings));
        },
        DOWNLOAD_DYSZ(state, dysz) {
            state.dysz = dysz;
            localStorage.setItem("dysz", JSON.stringify(state.dysz));
        },
        ADD_SETTING(state, { view, sub, Obj, key, value }) {
            state.settings ? "" : (state.settings = {});
            view && Object.hasOwnProperty.call(state.settings, view) ? "" : (state.settings[view] = {});
            sub && view != sub && Object.hasOwnProperty.call(state.settings[view], sub) ? "" : (state.settings[view][sub] = {});
            Obj && Object.hasOwnProperty.call(state.settings[view][sub], Obj) ? "" : (state.settings[view][sub][Obj] = {});
            if (Obj) {
                state.settings[view][sub][Obj][key] = value;
            } else {
                state.settings[view][sub][key] = value;
            }
            localStorage.setItem("settings", JSON.stringify(state.settings));
        },
        UPDATE_COMPANY(state, company) {
            state.company = company;
            localStorage.setItem("company", JSON.stringify(state.company));
        },
        ADD_DYSZ(state, { view, sub, Obj, key, value }) {
            state.dysz ? "" : (state.dysz = {});
            view && Object.hasOwnProperty.call(state.dysz, view) ? "" : (state.dysz[view] = {});
            sub && view != sub && Object.hasOwnProperty.call(state.dysz[view], sub) ? "" : (state.dysz[view][sub] = {});
            Obj && Object.hasOwnProperty.call(state.dysz[view][sub], Obj) ? "" : (state.dysz[view][sub][Obj] = {});
            if (Obj) {
                state.dysz[view][sub][Obj][key] = value;
            } else {
                state.dysz[view][sub][key] = value;
            }
            localStorage.setItem("dysz", JSON.stringify(state.dysz));
        },
        ClearCartItemw(state) {
            state.cartItems = [];
        },
        //停用
        UPDATE_DEFAULTSETTING(state, defaultSetting) {
            state.defaultSettings = defaultSetting;
        },
    },
    actions: {
        add_view({ commit }, view) {
            commit("ADD_VISITED_VIEW", view);
        },
        del_view({ commit }, view) {
            commit("DEL_VISITED_VIEW", view);
        },
        addToCart({ commit }, item) {

            commit('ADD_TO_CART', item);
            // commit('SAVE_CART_TO_LOCAL_STORAGE');
        },
        delToCart({ commit }, item) {
            commit('DEL_TO_CART', item);
            // commit('SAVE_CART_TO_LOCAL_STORAGE');
        },
        // loadCartFromLocalStorage({ commit }) {
        //     commit('LOAD_CART_FROM_LOCAL_STORAGE');
        // }
    },
    getters: {
        cartItems1: state => state.cartItems
    },
};
export default common;
